import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.JD2pwH',
    defaultMessage: 'Organizations',
  },
  error: {
    id: 'studio.kFjy+A',
    defaultMessage: 'Something went wrong trying to fetch the list of organizations',
  },
  empty: {
    id: 'studio.B02Lh+',
    defaultMessage: 'There are no organizations available.',
  },
  loading: {
    id: 'studio.0vTK7Q',
    defaultMessage: 'Loading organizations…',
  },
  logo: {
    id: 'studio.k81S1y',
    defaultMessage: 'Logo',
  },
  myOrganizations: {
    id: 'studio.19HUGI',
    defaultMessage: 'My organizations',
  },
  allOrganizations: {
    id: 'studio.Sg2bxJ',
    defaultMessage: 'All organizations',
  },
  noOrganizations: {
    id: 'studio.IGL0y6',
    defaultMessage: 'There are currently no organizations available.',
  },
  createButton: {
    id: 'studio.MNwj2I',
    defaultMessage: 'Create new organization',
  },
  createTitle: {
    id: 'studio.4xkhgP',
    defaultMessage: 'Creating new organization',
  },
  createVerify: {
    id: 'studio.4M0fNr',
    defaultMessage:
      'In order to create a new organization you must first verify your email address. Refresh the page once you have verified your email.',
  },
});
